export const ethnicityArray = [
  {
    code: '2137-8',
    display: 'Spaniard',
  },
  {
    code: '2138-6',
    display: 'Andalusian',
  },
  {
    code: '2139-4',
    display: 'Asturian',
  },
  {
    code: '2140-2',
    display: 'Castillian',
  },
  {
    code: '2141-0',
    display: 'Catalonian',
  },
  {
    code: '2142-8',
    display: 'Belearic Islander',
  },
  {
    code: '2143-6',
    display: 'Gallego',
  },
  {
    code: '2144-4',
    display: 'Valencian',
  },
  {
    code: '2145-1',
    display: 'Canarian',
  },
  {
    code: '2146-9',
    display: 'Spanish Basque',
  },
  {
    code: '2148-5',
    display: 'Mexican',
  },
  {
    code: '2149-3',
    display: 'Mexican American',
  },
  {
    code: '2150-1',
    display: 'Mexicano',
  },
  {
    code: '2151-9',
    display: 'Chicano',
  },
  {
    code: '2152-7',
    display: 'La Raza',
  },
  {
    code: '2153-5',
    display: 'Mexican American Indian',
  },
  {
    code: '2155-0',
    display: 'Central American',
  },
  {
    code: '2156-8',
    display: 'Costa Rican',
  },
  {
    code: '2157-6',
    display: 'Guatemalan',
  },
  {
    code: '2158-4',
    display: 'Honduran',
  },
  {
    code: '2159-2',
    display: 'Nicaraguan',
  },
  {
    code: '2160-0',
    display: 'Panamanian',
  },
  {
    code: '2161-8',
    display: 'Salvadoran',
  },
  {
    code: '2162-6',
    display: 'Central American Indian',
  },
  {
    code: '2163-4',
    display: 'Canal Zone',
  },
  {
    code: '2165-9',
    display: 'South American',
  },
  {
    code: '2166-7',
    display: 'Argentinean',
  },
  {
    code: '2167-5',
    display: 'Bolivian',
  },
  {
    code: '2168-3',
    display: 'Chilean',
  },
  {
    code: '2169-1',
    display: 'Colombian',
  },
  {
    code: '2170-9',
    display: 'Ecuadorian',
  },
  {
    code: '2171-7',
    display: 'Paraguayan',
  },
  {
    code: '2172-5',
    display: 'Peruvian',
  },
  {
    code: '2173-3',
    display: 'Uruguayan',
  },
  {
    code: '2174-1',
    display: 'Venezuelan',
  },
  {
    code: '2175-8',
    display: 'South American Indian',
  },
  {
    code: '2176-6',
    display: 'Criollo',
  },
  {
    code: '2178-2',
    display: 'Latin American',
  },
  {
    code: '2180-8',
    display: 'Puerto Rican',
  },
  {
    code: '2182-4',
    display: 'Cuban',
  },
  {
    code: '2184-0',
    display: 'Dominican',
  },
  {
    code: '2186-5',
    display: 'Not Hispanic or Latino',
  },
  {
    code: 'ASKU',
    display: 'Asked but Unknown',
  },
  {
    code: 'OTH',
    display: 'Other',
  },
  {
    code: 'UNK',
    display: 'Unknown',
  },
  {
    code: 'NS',
    display: 'Not Specified',
  },
];
